module.exports = __webpack_public_path__ + "img/advantages-back-768_2x.6ea546c6.jpg";